import { ERecouvrement } from "./enum/recouvrement";

export class IBMRFaciesEcoulement {
    Radier: ERecouvrement = ERecouvrement.Absent;
    Cascade: ERecouvrement = ERecouvrement.Absent;
    Mouille: ERecouvrement = ERecouvrement.Absent;
    Rapide: ERecouvrement = ERecouvrement.Absent;
    FosseDissipation: ERecouvrement = ERecouvrement.Absent;
    ChenalLotique: ERecouvrement = ERecouvrement.Absent;
    PlatLentique: ERecouvrement = ERecouvrement.Absent;
    ChenalLentique: ERecouvrement = ERecouvrement.Absent;
    ZoneDeBordure: ERecouvrement = ERecouvrement.Absent;
    PlatCourant: ERecouvrement = ERecouvrement.Absent;
    Autre: ERecouvrement = ERecouvrement.Absent;
    AutreDescription: string;
    
    static mapFromJSON(json): IBMRFaciesEcoulement {
        const fe = new IBMRFaciesEcoulement();

        fe.Radier = json.radier;
        fe.Cascade = json.cascade;
        fe.Mouille = json.mouille;
        fe.Rapide = json.rapide;
        fe.FosseDissipation = json.fosseDissipation;
        fe.ChenalLotique = json.chenalLotique;
        fe.PlatLentique = json.platLentique;
        fe.ChenalLentique = json.chenalLentique;
        fe.ZoneDeBordure = json.zoneDeBordure;
        fe.PlatCourant = json.platCourant;
        fe.Autre = json.autre;
        fe.AutreDescription = json.autreDescription;

        return fe;
    }
}